import React from "react";
import MLIcon from "../../../../../../components/MLIcon/MLIcon";
import s from './QQInsightsCompletedAssignment.module.css';

const WidgetStat = ({ label, icon, value }) => (
  <div className={s.dataBox}>
    <MLIcon
      className={s.dataDisplayIcon}
      type={icon}
      height={32}
      width={32}
      role="presentation"
      viewBox="0 0 32 32"
    />
    <div className={s.dataValue}>{value}</div>
    <div className={s.dataLabel}>{label}</div>
  </div>
);

const QQInsightsCompletedAssignment = ({ data: { didNotOpen, inProgress, openNotStarted, completed } }) => (
  <div className={s.qqCompletedAssignment}>
    <WidgetStat value={completed || 0} icon="circle_check_outline" label="Completed" />
    <WidgetStat value={didNotOpen || 0} icon="hidden" label="Did Not Open" />
    <WidgetStat value={inProgress || 0} icon="refresh" label="In progress" />
    <WidgetStat value={openNotStarted || 0} icon="visible" label="Opened Without Starting" />
  </div>
);

export default QQInsightsCompletedAssignment;
